import React from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';

function CustomSelect({ value, onChange, options }) {
    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <select
                value={value}
                onChange={onChange}
                style={{
                    appearance: 'none',
                    padding: '4px 28px 4px 8px',
                    margin: "4px",
                    // Increased right padding to 30px
                    borderRadius: '4px',
                    backgroundColor: '#e9ecef',
                    border: '0.2px solid #ced4da',
                    cursor: 'pointer',
                    fontSize: '11px',
                    color: '#495057',
                    width: 'auto',
                    minWidth: '40px',
                    // boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
            >
                {options.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>
            <div
                style={{
                    position: 'absolute',
                    top: '44%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    fontSize: '17px',
                    color: '#495057',
                }}
            >
                <MdKeyboardArrowDown />
            </div>
        </div>
    );
}

export default CustomSelect;